import { useState } from 'react';
import { Search, X } from 'lucide-react';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Input } from '@/components/ui/input';
import { ScrollArea } from '@/components/ui/scroll-area';

interface MobileSearchProps {
  open: boolean;
  onClose: () => void;
}

export function MobileSearch({ open, onClose }: MobileSearchProps) {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <Sheet open={open} onOpenChange={onClose}>
      <SheetContent side="top" className="h-full p-0">
        <div className="flex flex-col h-full">
          {/* Search header */}
          <div className="flex items-center gap-3 p-4 border-b bg-background">
            <Search className="h-5 w-5 text-muted-foreground flex-shrink-0" />
            <Input
              autoFocus
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search contacts, deals, emails..."
              className="flex-1 border-0 focus-visible:ring-0 text-base h-12"
            />
            <button 
              onClick={onClose}
              className="flex-shrink-0 p-2 hover:bg-accent rounded-md"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Search results */}
          <ScrollArea className="flex-1">
            <div className="p-4">
              {searchQuery ? (
                <div className="space-y-4">
                  <p className="text-sm text-muted-foreground">
                    Searching for "{searchQuery}"...
                  </p>
                  {/* Search results will be implemented here */}
                </div>
              ) : (
                <div className="text-center py-8">
                  <Search className="h-12 w-12 text-muted-foreground mx-auto mb-3" />
                  <p className="text-sm text-muted-foreground">
                    Start typing to search across contacts, deals, and emails
                  </p>
                </div>
              )}
            </div>
          </ScrollArea>
        </div>
      </SheetContent>
    </Sheet>
  );
}
